import { Box } from '@mui/material';
import { FC } from 'react';
import { Dropdowns } from '../types';
import { PlayPauseButton } from './PlayPauseButton';
import { SecondaryButtons } from './SecondaryButtons';
import { TimePresentation } from './TimePresentation';
import { VolumeButton } from './VolumeButton';

type ButtonRowProps = {
  isPlaying: boolean;
  muted: boolean;
  position: number;
  duration: number;
  lookback: number;
  seekable: boolean;
  volume: number;
  activeDropdown: Dropdowns;

  onTogglePlaying(): void;
  onToggleMute(): void;
  onChangeVolume(val: number): void;
  onToggleFullscreen(): void;
  onToggleDropdown(kind: Dropdowns): void;
  onJumpLive(): void;
};

export const ButtonRow: FC<ButtonRowProps> = ({
  isPlaying,
  muted,
  position,
  duration,
  lookback,
  seekable,
  volume,
  activeDropdown,
  onTogglePlaying,
  onToggleMute,
  onChangeVolume,
  onToggleFullscreen,
  onToggleDropdown,
  onJumpLive,
}) => (
  <Box display="flex" alignItems="center" gap="16px">
    <PlayPauseButton isPlaying={isPlaying} onToggle={onTogglePlaying} />
    <VolumeButton muted={muted} toggleMute={onToggleMute} volume={volume} changeVolume={onChangeVolume} />
    <TimePresentation
      position={position}
      duration={duration}
      lookback={seekable ? lookback : 0}
      onJumpLive={onJumpLive}
    />
    <span style={{ flexGrow: 1 }}></span>
    <SecondaryButtons
      activeDropdown={activeDropdown}
      onToggleSpeed={() => onToggleDropdown('speed')}
      onToggleSubtitles={() => onToggleDropdown('subtitles')}
      onToggleFullscreen={onToggleFullscreen}
      onToggleVariants={() => onToggleDropdown('variants')}
      onToggleAudio={() => onToggleDropdown('languages')}
    />
  </Box>
);
